import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CanvasService } from '../canvas.service';

@Component({
  selector: 'app-chat-introduction',
  templateUrl: './chat-introduction.component.html',
  styleUrl: './chat-introduction.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatIntroductionComponent {
  constructor(private readonly canvasService: CanvasService) {}
  @Input() isEmbededChat: boolean = false;
  showVideo = false;
  videoUrl = '';
  boxes = [
    {
      id: 'knowledgeHub',
      iconPath: 'assets/icons/png/AIChat.png',
      title: 'Knowledge Hub',
      description:
        "Knowledge Hub is an AI-powered chat space where users can ask questions and receive instant, intelligent responses. It's designed to help you explore information, clarify concepts, and get quick answers — all through a simple conversational interface.",
    },
    {
      id: 'dataAnalytics',
      iconPath: 'assets/icons/png/DataCatelogue.png',
      title: 'Data Analytics',
      description:
        'Data Analytics using AI Chat lets you explore data through simple text prompts. Ask questions, and get instant charts or insights without coding — making data analysis fast, easy, and visual.',
    },
    {
      id: 'documentGeneration',
      iconPath: 'assets/icons/png/Content.png',
      title: 'Document Generation',
      description:
        'AI Document Generation helps you quickly create summaries, reports, or structured content from simple prompts—no formatting or manual writing needed. Fast, smart, and efficient.',
    },
  ];
  playVideo(url: string) {
    this.showVideo = true;
    this.videoUrl = this.canvasService.appSettings.content.settings[0].blob_url;
    setTimeout(() => {
      const video = document.getElementById(
        'centeredVideo'
      ) as HTMLVideoElement;
      video?.play();
    });
  }

  closeVideo() {
    this.showVideo = false;
  }
}
